var map = {
	"./1.png": 5321,
	"./2.png": 178,
	"./20.png": 376,
	"./21.png": 8241,
	"./3.png": 9179,
	"./4.png": 9236,
	"./5.png": 1741,
	"./6.png": 1062,
	"./7.png": 9151,
	"./8.png": 2600,
	"./9.png": 2545,
	"./kangkong-Kalmi Saag.png": 4901
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8993;